import { useState } from "react";
import axios from "../axios";
import { toast } from "react-toastify";

export const useOffers = () => {
    const [offerData, setOfferData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedOffers, setSelectedOffers] = useState({
        offerValidity: null,
        delivery: null,
        payment: null,
        incoterm: null,
        packing: null,
        warranty: null,
        forceMajeure: null
    });

    // Fetch offer data from API
    const fetchOffers = async () => {
        setLoading(true);
        try {
            const response = await axios.get("/project/get-offer-options");
            setOfferData(response.data);
            return response.data;
        } catch (error) {
            console.error("Error fetching offers:", error);
            toast.error("Failed to fetch offer data");
            return null;
        } finally {
            setLoading(false);
        }
    };

    // Load saved offers for a project
    const loadProjectOffers = async (projectId) => {
        try {
            const response = await axios.get(`/api/project/${projectId}/offers`);
            if (response.status === 200 && response.data) {
                const offers = {
                    offerValidity: response.data.offerValidity || null,
                    delivery: response.data.delivery || null,
                    payment: response.data.payment || null,
                    incoterm: response.data.incoterm || null,
                    packing: response.data.packing || null,
                    warranty: response.data.warranty || null,
                    forceMajeure: response.data.forceMajeure || null
                };
                setSelectedOffers(offers);
                return offers;
            }
            return null;
        } catch (error) {
            console.error("Error loading project offers:", error);
            return null;
        }
    };

    // Build summary string from selected offers
    const buildOfferSummary = (offers) => {
        const parts = [];
        
        if (offers?.offerValidity) {
            parts.push(`Offer Validity: ${offers.offerValidity.offerValue}`);
        }
        if (offers?.delivery) {
            parts.push(`Delivery: ${offers.delivery.offerValue}`);
        }
        if (offers?.payment) {
            parts.push(`Payment: ${offers.payment.offerValue}`);
        }
        if (offers?.incoterm) {
            parts.push(`Incoterm: ${offers.incoterm.offerValue}`);
        }
        if (offers?.packing) {
            parts.push(`Packing: ${offers.packing.offerValue}`);
        }
        if (offers?.warranty) {
            parts.push(`Warranty: ${offers.warranty.offerValue}`);
        }
        if (offers?.forceMajeure) {
            parts.push(`Force Majeure: ${offers.forceMajeure.offerValue}`);
        }

        return parts.join(" | ");
    };

    // Helper to get offer IDs for saving with project
    const getOfferIds = (offers) => {
        return {
            offerValidityId: offers?.offerValidity?.offerId || null,
            deliveryId: offers?.delivery?.offerId || null,
            paymentId: offers?.payment?.offerId || null,
            incotermId: offers?.incoterm?.offerId || null,
            packingId: offers?.packing?.offerId || null,
            warrantyId: offers?.warranty?.offerId || null,
            forceMajeureId: offers?.forceMajeure?.offerId || null
        };
    };

    return {
        offerData,
        loading,
        selectedOffers,
        setSelectedOffers,
        fetchOffers,
        loadProjectOffers,
        buildOfferSummary,
        getOfferIds
    };
};